/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import { getQuery } from "./util/helpers";

import {
	SET_PRODUCT_PACKAGES,
	SET_SELECTED_PRODUCT_PACKAGE,
} from "ducks/boosts";

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function boosts(state, action) {
	switch (action.type) {
		case SET_PRODUCT_PACKAGES: {
			const { productPackages } = action.payload;

			Analytics.logUIEvent(
				Analytics.eventNames.viewedRateCard,
				{
					data: {
						"feature": "boost",
						"feature type": "token",
						"rate card name": action.payload.rateCardName,
						"token package mix": productPackages.map((product) => product.tokensNumber)
							.reverse().join(", "),
						"total token package price": productPackages.map((product) => product.initialPrice / 100)
							.reverse().join(", "),
						"upsell logic": action.payload.discountId,
						"camefrom": getQuery("cf"),
					},
				}
			);

			return;
		}

		case SET_SELECTED_PRODUCT_PACKAGE: {
			const { selectedProductPackage } = action.payload;
			const { total, tokensNumber } = selectedProductPackage;

			Analytics.logUIEvent(
				Analytics.eventNames.purchasesSelectedPlanOnBoostTokenUpsell,
				{
					data: {
						"number of boost tokens purchased": tokensNumber,
						"gross proceeds in local currency": total / 100,
					},
				}
			);

			Analytics.logUIEvent(
				Analytics.eventNames.selectedPackageOnRateCard,
				{
					data: {
						"feature": "boost",
						"feature type": "token",
						"rate card name": state.rateCardName,
						"total token package price": selectedProductPackage.initialPrice / 100,
						"token package": selectedProductPackage.tokensNumber,
					},
				}
			);

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/boosts.js